import filterServicesCatalog from './filterServicesCatalog';

const excludeServicesWithoutOffice = catalog => filterServicesCatalog(
    catalog,
    service => service.officesIds.length !== 0
  );

export default excludeServicesWithoutOffice;
